<template>
<div style="background-color: white">


<!--   <Section background="white"  class="image-bg"-->
<!--            :style="{'background-image': `url(${require('../../assets/images/content/pexels-pixabay-33153.jpg')})`}"-->

<!--   >-->

<!--      <nav-bar dark></nav-bar>-->
<!--      &lt;!&ndash;      <div class=" main-heading heading-line pt-1">&ndash;&gt;-->
<!--      &lt;!&ndash;      </div>&ndash;&gt;-->

<!--&lt;!&ndash;      <div class=" main-heading heading-line" style=" width: 100%;" >&ndash;&gt;-->
<!--&lt;!&ndash;      </div>&ndash;&gt;-->

<!--      <div class=" main-heading" style=" width: 100%;" >-->
<!--         <v-container fluid class="heading-line">-->

<!--            <div class="center display-2">Living The Bible</div>-->
<!--            <div class="center display-1">Radio Archive</div>-->


<!--         </v-container>-->
<!--      </div>-->


<!--   </Section>-->


   <div style="height: 30px">

   </div>



   <div style="display: flex; justify-content: center">
      <table>
         <tr>
            <th></th>
            <th style="text-align: left">Episode Title</th>
            <th>Player Controls</th>
         </tr>

         <tr
             v-for="(item, ix) in file_list" :key="ix"
             style="border-bottom:5px solid red; "
         >
            <td>
               {{ix+1}}
            </td>
            <td >
               {{item.title}}
            </td>
            <td style="width:300px">
               <AudioPlayer :file="item.filename"/>
            </td>
         </tr>
      </table>
   </div>




</div>
</template>

<script>

import navBar from '@/components/navBar.vue'
import Section from "@/components/Section";
import AudioPlayer from "@/components/AudioPlayer";

import files from '@/assets/data/living_the_bible_clean.json'

export default {
   name: "Radio",
   components: {navBar, Section, AudioPlayer},
   data(){
      return{
         file_list: files
      }
   },

   created() {

   }
}
</script>

<style scoped>
.image-bg{
   background-size: cover;
   background-position: center;
   height: 300px;
}

   td{
      padding-left: 10px;
      padding-right: 10px;
   }


.main-heading{
   height: 200px;
   display: flex;
   align-items: center;
   justify-content: center;

}


.heading-line{
   text-align: center;
   color:#ffffff;
   /*background-color:rgba(43,43,43,0.4);*/
   width: 100%;

}

</style>
